// contexts/CampaignProvider.tsx
import React, { type ReactNode } from 'react';
import { CampaignContext } from './CampaignContext';
import { useCampaignData } from '@/hooks/campaign/useCampaignData';

export const CampaignProvider = ({ children }: { children: ReactNode }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const campaignData = useCampaignData() as any;

    if (!campaignData) {
        console.error('CampaignProvider: useCampaignData returned null');
        return null;
    }

    return <CampaignContext.Provider value={campaignData}>{children}</CampaignContext.Provider>;
};
